import React, { useState, useEffect } from "react";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import configs, { getParameterByName } from "../Constants";
import { json } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import Paper from '@mui/material/Paper';
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import CloseIcon from "@mui/icons-material/Close";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import Divider from '@mui/material/Divider';
import TablePagination from "@mui/material/TablePagination";
import CircularProgress from '@mui/material/CircularProgress';
import { Table, Thead, Tbody, Tr, Th, Td } from "react-responsive-list";
import "react-responsive-list/assets/index.css";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuList from '@mui/material/MenuList';
import useScanDetection from 'use-scan-detection';
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import { FormControlLabel } from "@mui/material";
import InventoryProLink from './sub_comp/InventoryProLink';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardContent,
  Typography,
  DialogActions,
  DialogContent,
  DialogContentText,

} from "@mui/material";
import Gallery from "./Gallery";
import Currencies from "../root/currency";
import DeleteDiaologue from "./sub_comp/Delete";
import Autocomplete from "@mui/material/Autocomplete";
import AddLinkIcon from '@mui/icons-material/AddLink';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ProductOffers from './sub_comp/ProductOffers';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";


function FoodDescription() {
  const [addonsGroup, setAddonsGroup] = useState([]);
  const [categories, setCategories] = useState([]);
  const [foodName, setFoodName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [kitchenList, setKitchenList] = useState([]);
  const [selectedKitchen, setSelectedKitchen] = useState("");
  const [price, setPrice] = useState(0);
  const [onlineIncreaseBy, setOnlineIncreaseBy] = useState(0);
  const [calorie, setCalorie] = useState(0);
  const [inStock, setInstock] = useState(true);
  const [description, setDescription] = useState("");
  const [imageURL, setImageURL] = useState(
    "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
  );
  const [categoryType, setCategoryType] = useState("");
  const [variety, setVariety] = useState(false);
  const [option, setOption] = useState([]);
  const [hideProductList, setHideProductList] = useState(false);
  const [selectProductId, setSelectProductId] = useState(0);
  const [hideEdit, setHideEdit] = useState(false);
  const [products, setProducts] = useState([]);
  const [catItem, setCatItem] = useState();
  const [catType, setCatType] = useState();
  const [proStack, setProStack] = useState();
  const [catId, setCatId] = useState(0);
  const [tags, setTags] = useState();
  const [cooktags, setCookTags] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterPro, setFilterPro] = useState([]);
  const [addOn, setAddOn] = useState([]);
  const [select, setSelect] = useState("");
  const [pricevalues, SetPriceValues] = useState({});
  const [selOption, setSeloption] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(7);
  const [image, setImage] = useState(false);
  const [optMap, setOptMap] = useState();
  const [isUploading, setUploading] = useState(false);
  const [showAddon, setShowAddon] = useState(false);
  const [isPriceEditable, setEditablePrice] = useState(false);
  const [containerPrice, setContainerPrice] = useState(0);
  const [isContainer, setIsContainer] = useState(false);
  const [containerPriceValues, setContainerPriceValues] = useState({});

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteItemName, setDeleteItemName] = useState("");

  const [showInventory, setShowInventory] = useState(false);
  const [showOffers, setShowOffers] = useState(false);
  const [allOffers, setAllOffers] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [openActions, setOpenActions] = React.useState(false);
  const [priceType, setPriceType] = useState("quantity");
  const [weightUnit, setWeightUnit] = useState("kg");
  const [weightPrice, setWeightPrice] = useState(0);
  const [weightPriceValues, setWeightPriceValues] = useState({});
  const [hasESL, setHasESL] = useState(false);
  const [eslCode, setEslCode] = useState("");
  const [SKU_id, setSKU] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [basePrice, setBasePrice] = useState(0);
  const [tax, setTax] = useState(0);
  const [itemImgCollection, setItemImgCollection] = useState([]);
  const [showGalleryCollection, setShowGalleryCollection] = useState(false);

  const handleSelectItem = (id) => {
    setSelectedProducts((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (visibleProducts) => {
    const visibleIds = visibleProducts.map((p) => p.id);
    const allSelected = visibleIds.every((id) => selectedProducts.includes(id));

    if (allSelected) {
      setSelectedProducts((prev) =>
        prev.filter((id) => !visibleIds.includes(id))
      );
    } else {
      setSelectedProducts((prev) => [
        ...new Set([...prev, ...visibleIds]),
      ]);
    }
  };

  const getVarietyOptions = () => {
    const selectedOpt = option.find((opt) => opt.id === select);
    return selectedOpt ? selectedOpt.items.split(",") : [];
  };

  //add by sk
  const [selectedCategory, setSelectedCategory] = useState("");
  let baseURL = configs.baseURL;
  // let baseURL = "https://inventory-service-gthb.onrender.com"
  let staticSer = configs.staticSer;
  const userToken = localStorage.getItem("token") || "";

  const [userInfo, setUserInfo] = useState([]);
  const [showGallery, setShowGallery] = useState(false);
  const handleSelectedImage = (image) => {
    setSelectedImage(image);
  };

  useEffect(() => {
    const fetchKitchens = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/api/kitchens?merchantCode=${merchCode}`
        );
        setKitchenList(response.data); // Assuming response.data is an array of kitchens
      } catch (error) {
        console.error("Error fetching kitchens:", error);
      }
    };

    if (merchantData?.bizVertical == 'restaurant') { fetchKitchens(); }
    fetchOffers();
  }, []);

  useScanDetection({
    onComplete: (code) => {
      if (code.length) {
        if (hideProductList || hideEdit) {
          setSKU(code);
        } else {
          setSearchText(code);
          filterProducts(null, code);
        }
      }
    }
  });

  const handleGallery = () => {
    setShowGallery(true);
  };

  useEffect(() => {
    const handleNativeMessage = (event) => {

      if (event?.detail?.skuCode) {
        let code = event?.detail?.skuCode || "";
        setSearchText(code);
        filterProducts(null, code);
      }

    };

    // Add event listener
    window.addEventListener('nativeOsMessage', handleNativeMessage);

    // Cleanup function to remove the listener when the component unmounts
    return () => {
      window.removeEventListener('nativeOsMessage', handleNativeMessage);
    };
  }, [products]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleSubmitImage = () => {
    if (selectedImage) {
      // Perform any other actions with the selected image
    } else {
      console.error("No image selected!");
    }
    setShowGallery(false); // Close the dialog after submission
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const removeTags = (indexToRemove) => {
    setCookTags([...cooktags.filter((_, index) => index !== indexToRemove)]);
  };
  const addTags = (event) => {
    if (event.target.value !== "") {
      setCookTags([...cooktags, event.target.value]);
      //props.selectedTags([...tags, event.target.value]);
      event.target.value = "";
    }
  };
  let userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";

  let merchantData = localStorage.getItem("merchantData")
    ? JSON.parse(localStorage.getItem("merchantData"))
    : null;
  const merchCode = merchantData ? merchantData.merchantCode : "";
  const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
    style: 'currency',
    currency: merchantData.currency || 'USD'
  });

  let currency = Currencies.filter(
    (curen) => curen.abbreviation == merchantData.currency
  );
  let SelectCurrency = currency && currency[0] ? currency[0].symbol : "";
  const selectedCurrency = (
    <span dangerouslySetInnerHTML={{ __html: SelectCurrency }} />
  );

  const userId = userData ? userData.sub : " ";
  const getCatByUser = `${baseURL}/api/categories?merchantCode=${merchCode}`;
  const getProductByUser = baseURL + `/api/products?merchantCode=${merchCode}`;
  const getVariety = baseURL + `/api/varieties?merchantCode=${merchCode}`;

  const handleCategoryType = (event) => {
    setCategoryType(event.target.value);
  };

  const handleFoodNameChange = (event) => {
    setFoodName(event.target.value);
  };
  const handleChangeVariety = (e) => {
    setVariety(e.target.checked);
    axios.get(getVariety).then((response) => {
      setOption(response.data);
    });
  };
  useEffect(() => {
    axios.get(getVariety).then((response) => {
      setOption(response.data);
    });
  }, []);

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    setSelect(selectedValue);

    let opt = option.filter((opt) => opt.id === selectedValue);
    let optmap = opt.map((optmap, index) => optmap.items.split(","));
    optmap.map((items, index) => {
      let obj = {};
      items.forEach((item) => {
        obj[item] = "";
      });
    });
  };

  useEffect(() => {
    const opt = option.filter((opt) => opt.id === select);
    setOptMap(opt.map((optmap, index) => optmap.items.split(",")));
  }, [option, select]);

  const handleInputChange = (e) => {
    var formData = new FormData();
    let file = e.target.files[0];
    let fileName = "pro_" + new Date().getTime() + file.name.replace(/\s+/g, "");
    setUploading(true);
    formData.append("uploader", file, fileName);
    let postQueriesUrl = baseURL + "/api/upload/INVENTORY_ITEM";
    axios.post(postQueriesUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then(res => {

      setUploading(false);
      //setImageURL(res.data?.results[0]?.location)
      setImageURL(`${configs.staticSer}/INVENTORY_ITEM/${fileName}`);
      console.log(res);
    });


    //setImageURL(file);
  };

  const handlePriceChange = (event) => {
    setPrice(event.target.value);
  };

  const handleContainerPriceChange = (event) => {
    setContainerPrice(event.target.value);
  };
  const handleCalorieChange = (event) => {
    setCalorie(event.target.value);
  };

  const handleInStockChange = (event) => {
    setInstock(event.target.value);
  };

  const handleTagsChange = (event) => {
    setTags(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  const handleESLCodeChange = (event) => {
    setEslCode(event.target.value);
  };

  const handleSkuChange = (event) => {
    setSKU(event.target.value);
  };

  const handleBasePriceChange = (event) => {
    setBasePrice(event.target.value);
  };

  const handleTaxChange = (event) => {
    setTax(event.target.value);
  };

  let catAddongrp;
  if (categories.length) {
    catAddongrp = [...categories, ...addonsGroup];
  }

  const handleClose = () => {
    resetVars();
  };

  const setTextValue = (value, item, field = "price") => {
    if (field === "price") {
      SetPriceValues((prev) => ({
        ...prev,
        [item]: value,
      }));
    } else if (field === "container") {
      setContainerPriceValues((prev) => ({
        ...prev,
        [item]: value,
      }));
    }
  };


  const handleSubmit = (event) => {
    event.preventDefault();
    if (!foodName || !catId) {
      const catElement = document.getElementsByClassName("category")[0];
      if (catElement) {
        catElement.style.borderColor = "red";
      }

      const nameElements = document.getElementsByClassName("name");
      if (nameElements && nameElements.length > 1) {
        if (nameElements[0]) {
          nameElements[0].innerHTML = "required";
        }
        if (nameElements[1]) {
          nameElements[1].style.borderColor = "red";
        }
      }
      return;
    }
    if (selectProductId) {
      // Update existing product
      axios
        .patch(
          baseURL +
          "/api/products/" +
          selectProductId +
          "?merchantCode=" +
          merchCode,
          {
            cat_type: categoryType,
            category: catId,
            name: foodName,
            description: description,
            image:
              selectedImage && selectedImage.image
                ? selectedImage.image
                : imageURL,
            isPriceVariety: variety,
            varietyGroupId: select.toString(),
            varietyPrices: JSON.stringify(pricevalues),
            cookInstructions: cooktags.length ? cooktags.join(",") : "",
            // price: price,
            container_price: isContainer ? (variety ? 0 : containerPrice) : 0,
            container_varietyPrice:
              isContainer && variety
                ? JSON.stringify(containerPriceValues)
                : null,

            calorie: calorie,
            inStock: inStock,
            id: selectProductId,
            tags: tags,
            add_ons: addOn.length ? addOn.join(",") : "",
            userId: userId,
            isPriceEditable: isPriceEditable,
            kitchenId: selectedKitchen,
            price: price,
            onlineIncreaseBy: onlineIncreaseBy,
            weight_price: weightPrice,
            is_weight_type: priceType === "weight",
            weight_unit: priceType === "weight" ? weightUnit : "kg",
            eslCode: eslCode,
            hasESL: hasESL,
            SKU_id: SKU_id,
            basePrice: basePrice,
            tax: tax,
            itemImgCollection: itemImgCollection
          },
          { headers: { Authorization: `Bearer ${userToken}` } }
        )
        .then((response) => {
          getProductsList();
        });
      setHideProductList(false);
      setHideEdit(false);
    } else {
      // Create new product
      axios
        .post(
          baseURL + "/api/products?merchantCode=" + merchCode,
          {
            cat_type: categoryType,
            category: catId,
            name: foodName,
            description: description,
            image:
              selectedImage && selectedImage.image
                ? selectedImage.image
                : imageURL,
            // price: price,
            container_price: isContainer ? (variety ? 0 : containerPrice) : 0,
            container_varietyPrice:
              isContainer && variety
                ? JSON.stringify(containerPriceValues)
                : null,

            isPriceVariety: variety,
            varietyGroupId: select,
            varietyPrices: JSON.stringify(pricevalues),
            calorie: calorie,
            inStock: inStock ? inStock : false,
            tags: tags,
            cookInstructions: cooktags.length ? cooktags.join(",") : "",
            add_ons: addOn.length ? addOn.join(",") : "",
            userId: userId,
            isPriceEditable: isPriceEditable,
            price: price,
            onlineIncreaseBy: onlineIncreaseBy,
            weight_price: weightPrice,
            is_weight_type: priceType === "weight",
            weight_unit: priceType === "weight" ? weightUnit : "kg",
            eslCode: eslCode,
            hasESL: hasESL,
            SKU_id: SKU_id,
            basePrice: basePrice,
            tax: tax,
            itemImgCollection: itemImgCollection
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          getProductsList();
        });
      setHideProductList(false);
      setHideEdit(false);
    }
    // Reset states after submit
    resetVars();
  };

  const resetVars = () => {
    setCookTags("");
    setSelectedImage();
    setTags("");
    setInstock(true);
    setCatId("");
    setCalorie("");
    setFoodName("");
    setDescription("");
    setPrice("");
    setOnlineIncreaseBy("");
    setContainerPriceValues({});
    setVariety(false);
    setSelect("");
    SetPriceValues("");
    setInstock(true);
    setImageURL(
      "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
    );
    setCookTags([]);
    setAddOn([]);
    setCatType("");
    setProStack("");
    setCatItem("");
    setSelectProductId("");
    setEditablePrice(false);
    setHideProductList(false);
    setHideEdit(false);
    setHasESL(false);
    setSKU(false);
    setEslCode(false);
    setSelectedProducts([]);
    setItemImgCollection([]);
    setShowGalleryCollection(false);
  }

  useEffect(() => {
    if (!categories.length) {
      axios.get(getCatByUser).then((response) => {
        if (response.data.length !== categories.length) {
          setCategories(response.data);
        }
      });
    }
  }, []);

  useEffect(() => {
    getProductsList();
  }, []);

  const getProductsList = () => {
    axios.get(getProductByUser).then((response) => {
      if (response.data) {
        setProducts(response.data);
        let addons = [];
        addons = categories.filter((c) => c.isAddOn);
        let addIds = addons.map((a) => a.id);
        setAddonsGroup(
          response.data.filter((pro) => addIds.indexOf(pro.category) !== -1)
        );

        if (searchText) {
          let filter = response.data.filter(
            (li) => (
              String(li?.name || "").toLowerCase().indexOf(searchText?.toLowerCase()) != -1 ||
              String(li?.SKU_id || "").toLowerCase().indexOf(searchText?.toLowerCase()) != -1
            )
          );
          setFilterPro(filter);
        }
      }
    });
  };
  const handleCategoryId = (event, catId) => {
    let selectCatId = event?.target?.value || catId;
    setCatId(selectCatId);
    setCatItem(selectCatId);
    let addonsval = categories.filter((addcat) => addcat.isAddOn === true);
    let addvalue = addonsval.filter((addonval) => addonval.id === selectCatId);
    if (addvalue.length > 0) {
      setShowAddon(false);
    } else {
      setShowAddon(true);
    }
  };
  const handleUpload = () => {
    setImage(true);
  };
  const handleDelete = (id) => {
    const product = products.find((prod) => prod.id === id);
    setDeleteItemName(product?.name || "this item");
    setDeleteItemId(id);
    setOpenDeleteDialog(true);
  };

  const handleDeleteClose = () => {
    setOpenDeleteDialog(false);
    setDeleteItemId(null);
  };

  const handleConfirmDelete = () => {
    if (deleteItemId) {
      axios.delete(`${baseURL}/api/products/${deleteItemId}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }).then(() => {
        getProductsList();
        handleDeleteClose();

      });
    }

  };

  const handleBulkDelete = async () => {
    if (selectedProducts.length === 0) return;

    if (window.confirm(`Are you sure you want to delete ${selectedProducts.length} selected items?`)) {
      try {
        const deletePromises = selectedProducts.map(id =>
          axios.delete(`${baseURL}/api/products/${id}`, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          })
        );
        await Promise.all(deletePromises);
        toast.success("Successfully deleted selected items!");
        setSelectedProducts([]);
        getProductsList();
      } catch (error) {
        toast.error("Failed to delete some items.");
        console.error("Bulk delete error:", error);
      }
    }
  };

  const handleEdit = (
    pro_id,
    pro_image,
    pro_category,
    proCat_type,
    pro_stock,
    pro
  ) => {
    setHideEdit(true);
    setCatItem(pro_category);
    setCatType(proCat_type);
    setProStack(pro_stock);

    setSelectProductId(pro_id);
    if (pro_image) {
      setImageURL(pro_image);
    } else {
      setImageURL(imageURL);
    }
    axios.get(getVariety).then((response) => {
      setSeloption(response.data);
    });

    const prodata = [pro];

    setFoodName(prodata[0].name);
    setDescription(prodata[0].description);
    setVariety(prodata[0].isPriceVariety);
    if (prodata[0].isPriceVariety) {
      setSelect(prodata[0].varietyGroupId);
      SetPriceValues(JSON.parse(prodata[0].varietyPrices));
    }
    setPrice(prodata[0].price);
    setOnlineIncreaseBy(prodata[0].onlineIncreaseBy || 0);
    if (prodata[0].container_varietyPrice) {
      const containerVariety = JSON.parse(prodata[0].container_varietyPrice);
      setContainerPriceValues(containerVariety);
      setIsContainer(
        prodata[0].container_price > 0 ||
        Object.keys(containerVariety).length > 0
      );
    } else {
      setContainerPrice(prodata[0].container_price || 0);
      setIsContainer(prodata[0].container_price > 0);
    }

    setInstock(prodata[0].inStock);
    setCalorie(prodata[0].calorie);
    setTags(prodata[0].tags);
    setCookTags(
      prodata[0].cookInstructions ? prodata[0].cookInstructions.split(",") : []
    );
    setEditablePrice(prodata[0].isPriceEditable);
    setPriceType(prodata[0].is_weight_type ? "weight" : "quantity");
    setWeightUnit(prodata[0].weight_unit || "kg");
    setWeightPrice(prodata[0].weight_price || 0);

    setCatId(prodata[0].category);
    setAddOn(prodata[0].add_ons.split(",").filter((a) => a.length));
    handleCategoryId(null, prodata[0].category);
    setHasESL(prodata[0].hasESL);
    setEslCode(prodata[0].eslCode);
    setSKU(prodata[0].SKU_id);
    setItemImgCollection(prodata[0].itemImgCollection || []);
  };
  const fetchOffers = async () => {
    try {
      const res = await axios.get(
        `${baseURL}/api/offers?merchantCode=${merchCode}`,
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );
      console.log("offers fetched", res.data);
      setAllOffers(res.data);
    } catch (err) {
      console.error("Error fetching offers:", err);
    }
  };
  const handleStocks = (prod) => {
    axios
      .patch(
        baseURL + "/api/products/" + prod.id + "?merchantCode=" + merchCode,
        {
          inStock: prod.inStock ? false : true
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        getProductsList();
        toast.success("Updated InStock!");
      });
  };
  const filterProducts = (event, manualCode) => {
    let searchText = manualCode ? manualCode : event.target.value;
    setSearchText(searchText);
    console.log(products);
    let filter = products.filter(
      (li) => (
        String(li?.name || "").toLowerCase().indexOf(searchText?.toLowerCase()) != -1 ||
        String(li?.SKU_id || "").toLowerCase().indexOf(searchText?.toLowerCase()) != -1
      )
    );
    console.log(filter);
    setFilterOpen(searchText ? true : false);
    setFilterPro(searchText ? filter : []);
    setPage(0);
  };

  const removeAddons = (indexToRemove) => {
    setAddOn([...addOn.filter((_, index) => index !== indexToRemove)]);
  };
  const handleAddOns = (event) => {
    let val = event.target.value;
    if (val) {
      let existItem = addOn.filter((x) => x === val);
      const items = existItem.length
        ? addOn.map((x) => (x === existItem[0] ? val : x))
        : [...addOn, val];
      setAddOn(items);
    }
  };
  let cat_ad = [];

  if (categories && products) {
    let adFilter = categories.filter((cat) => cat.isAddOn);
    let addPro = products.filter((pro) =>
      adFilter.filter((li) => {
        if (li.id === pro.category) {
          cat_ad.push(pro);
        }
      })
    );
  }

  const imageOnErrorHandler = (event) => {
    event.currentTarget.src = "/images/blank.jpeg";
  };

  let catAddon = categories;
  let prod = filterOpen ? (filterPro.length ? filterPro : []) : products;



  const handleShowProductForm = () => {
    setSelectProductId("");
    setHideProductList(true);
  };

  const handleKitchenChange = (event) => {
    setSelectedKitchen(event.target.value);
  };


  const handleActionsClick = (pro_id) => {
    if (selectProductId === pro_id) {
      setOpenActions(!openActions);
    } else {
      setSelectProductId(pro_id);
      setOpenActions(true);
    }
  };

  const handleActionsClose = () => {
    console.log(openActions);
    setOpenActions(false);
  };

  const showInventoryDialog = (foodName) => {
    setShowDialog(true);
    setShowInventory(foodName);
    setOpenActions(false);

  }

  const showOffersDialog = (product) => {
    setShowOffers(product);
    setOpenActions(false);
  }

  const handleExportLabels = async () => {
    let selectedItems = products.filter((p) => selectedProducts.includes(p.id));
    if (selectedItems.length === 0) {
      toast.warn("Please select items to export labels.");
      return;
    }
    if (window.PrintLabelInterface) {
      let labelsItems = [];
      selectedItems.map(p => {
        // Find offer for the product
        // const offer = allOffers.find(o => (o.productId.toString() === p.id.toString()));
        let currentPrice = p.price;
        let discountAmountPerItem = 0;

        // if (offer) {
        //   if (offer.overridePrice !== undefined && offer.overridePrice !== null && offer.overridePrice !== 0) {
        //     currentPrice = parseFloat(offer.overridePrice);
        //   }

        //   const X = parseInt(offer.X) || 0;
        //   const Y = parseInt(offer.Y) || 0; // This is Y for FREE or % for discount types

        //   if (offer.type === "Flat % OFF") {
        //     p.appliedOfferDescription = `${Y}% OFF`;
        //   } else if (offer.type === "BUY X GET % OFF") {
        //     p.appliedOfferDescription = `BUY ${X} GET ${Y}% OFF`;
        //   }
        //   else if (offer.type === "BUY X GET Y FREE") {
        //     p.appliedOfferDescription = `BUY ${X} GET ${Y} FREE`;
        //   }
        //   else if (offer.type === "BUY X FOR FLAT Y") {
        //     p.appliedOfferDescription = `BUY ${X} FOR FLAT ${Y}`;
        //   }
        //   else {
        //     p.appliedOfferDescription = "";
        //   }
        // }

        labelsItems.push({
          name: p.name,
          price: p.isPriceVariety && p.varietyPrices
            ? Object.values(JSON.parse(p.varietyPrices)).join(
              '/'
            ) : '$' + (p.price || p.weight_price),
          sku: `${p.SKU_id || '0000'}`,
          offer: ""
        });
      })
      console.log(labelsItems);
      window?.PrintLabelInterface?.print(JSON.stringify(labelsItems));
      setSelectedProducts([]);
      return;
    }

    const decodeEntities = (text) => {
      if (!text) return "";
      const textArea = document.createElement('textarea');
      textArea.innerHTML = text;
      return textArea.value;
    };

    const currencySymbol = decodeEntities(SelectCurrency || "$");

    // Pixel-based settings (80mm is ~300px at 96 DPI)
    const labelW = 300;
    const singleLabelH = 160; // Each label block height in pixels
    const totalHeight = selectedItems.length * singleLabelH;

    const doc = new jsPDF({
      orientation: "p",
      unit: "px",
      format: [labelW, totalHeight],
      hotfixes: ["px_scaling"]
    });

    const loadImage = (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error("Image fail"));
        img.src = url;
        setTimeout(() => reject(new Error("Timeout")), 6000);
      });
    };

    toast.info(`Generating ${selectedItems.length} labels in pixels (80mm width)...`);

    for (let i = 0; i < selectedItems.length; i++) {
      const p = selectedItems[i];
      const startY = i * singleLabelH;

      // Margins in pixels
      const padX = 15;
      const padY = 10;
      const contentW = labelW - (padX * 2);

      // 1. Product Name
      doc.setFontSize(18);
      doc.setFont("helvetica", "bold");
      const nameText = p.name || "Product";
      doc.text(nameText, padX, startY + padY + 20, { maxWidth: contentW });



      // 3. SKU Barcode
      const sku = p.SKU_id || "0000";
      const barcodeUrl = `https://bwipjs-api.metafloor.com/?bcid=code128&text=${encodeURIComponent(sku)}&scale=3&rotate=N&includetext`;

      try {
        const img = await loadImage(barcodeUrl);
        // User adjusted barcode to startY + padY + 20
        doc.addImage(img, 'PNG', padX, startY + padY + 35, contentW, 70);
      } catch (e) {
        console.error("Barcode failed for", sku, e);
        doc.setFontSize(14);
        doc.setFont("helvetica", "normal");
        doc.text(`SKU: ${sku}`, padX, startY + padY + 30);
      }

      // 2. Prize/Price - Fixed "1" issue
      doc.setFontSize(24);
      doc.setFont("helvetica", "bold");
      const price = p.price || "0";
      // Format number manually and prepend already-decoded currencySymbol (e.g. J$, $, etc)
      const formattedPrice = Number(price).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const priceText = `N$${formattedPrice}`;
      doc.text(priceText, padX, startY + padY + 145);

      // Subtle separator
      if (i < selectedItems.length - 1) {
        doc.setDrawColor(220);
        doc.line(10, startY + singleLabelH, labelW - 10, startY + singleLabelH);
      }
    }

    doc.save("product_labels_px_80mm.pdf");
    toast.success("Labels exported successfully!");
  };
  return (
    <>
      <div className="container" style={{ padding: "16px", paddingTop: "8px", height: "calc(100vh - 60px)" }}>
        <div className="header">
          <h4 className="">Items</h4>
          <div className="search">
            <SearchIcon />
            <input
              type="text"
              value={searchText}
              onChange={filterProducts}
              placeholder="Enter Name/SKU ..."
              style={{
                border: "none",
                outline: "none",
                width: "87%",
                backgroundColor: "transparent",
              }}
            />
          </div>

          {/* add by sk */}
          <div>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              <InputLabel id="category-select-label">
                <label>Category</label>
              </InputLabel>
              <Select
                labelId="category-select-label"
                id="category-select"
                value={selectedCategory || ""}
                label="Category"
                size="small"
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                <MenuItem value="">
                  <em>All</em>
                </MenuItem>
                {categories.map((category) => (
                  <MenuItem key={category.id} value={category.name}>
                    {category.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          {selectedProducts.length > 0 && (
            <div style={{ marginLeft: "10px", display: "flex", gap: "10px" }}>
              <Button
                variant="contained"
                startIcon={<DeleteIcon />}
                onClick={handleBulkDelete}
                style={{ backgroundColor: "#d32f2f", color: "#fff" }}
              >
                Bulk Delete
              </Button>
              <Button
                variant="contained"
                color="primary"
                startIcon={<FileCopyIcon />}
                onClick={handleExportLabels}
                style={{ backgroundColor: "#3622cc", color: "#fff" }}
              >
                Export Labels
              </Button>
            </div>
          )}
          {merchCode && !merchCode.activeProviderId ? (
            <button
              className="add_btn"
              onClick={handleShowProductForm}
            >
              <AddIcon /> Add New
            </button>
          ) : (
            <span></span>
          )}
        </div>



        <Dialog
          open={hideProductList || hideEdit}
          maxWidth="lg"
          fullWidth={true}
        >

          <DialogTitle style={{ fontWeight: "bold" }}>
            {hideEdit ? "Edit Products" : "Add Products"}
          </DialogTitle>

          <IconButton
            aria-label="close"
            onClick={resetVars}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <div>
              {hideProductList || hideEdit ? (
                <>
                  <form>
                    <FormControl sx={{ m: 1, minWidth: 150 }}>
                      <InputLabel id="demo-simple-select-helper-label">
                        Category
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        label="Category"
                        value={catId}
                        onChange={(e) => handleCategoryId(e)}
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {catAddon &&
                          catAddon.length &&
                          catAddon.map((cat) => (
                            <MenuItem
                              key={cat.id}
                              value={cat.id}
                              selected={catItem === cat.id}
                            >
                              {cat.name}
                              {cat.isAddOn ? (
                                <span
                                  className="MuiChip-filledError MuiChip-filled"
                                  style={{
                                    padding: "3px 7px",
                                    marginLeft: "5px",
                                  }}
                                >
                                  {"ADD-ON"}
                                </span>
                              ) : (
                                ""
                              )}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    <br />
                    <div className="row">
                      <div className="col">
                        <Box
                          noValidate
                          autoComplete="off"
                        >
                          <TextField
                            fullWidth
                            label="Name"
                            defaultValue=""
                            onChange={handleFoodNameChange}
                            name="foodname"
                            value={foodName}
                          />
                        </Box>
                      </div>

                      <div className="col">
                        <Box

                          noValidate
                          autoComplete="off"
                        >
                          <div>
                            <TextField
                              fullWidth
                              label="Description"
                              defaultValue=""
                              onChange={handleDescriptionChange}
                              name="description"
                              value={description}
                            />
                          </div>
                        </Box>
                      </div>
                    </div>
                    <br />
                    <div className="row dialog-row">
                      <label><b>Item Image </b></label>
                      <div className="col">
                        {isUploading && imageURL ? <CircularProgress color="secondary" /> : <img src={imageURL} style={{ width: "100px", height: "auto" }} />}
                      </div>
                      <div className="col">
                        <Box

                          noValidate
                          autoComplete="off"
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginLeft: "10px",
                            }}
                          >

                            <Button variant="contained" style={{ backgroundColor: "#000", color: "#fff", marginRight: "10px" }} onClick={handleGallery}>
                              Add From Gallery
                            </Button>
                            <Button variant="outlined" onClick={handleUpload}>
                              Upload New
                            </Button>
                          </div>
                        </Box>
                        <span style={{ fontSize: "1rem" }}>
                          {selectedImage ? selectedImage.name : ""}
                        </span>
                      </div>
                      <div
                        className="col"
                        style={image ? { display: "block" } : { display: "none" }}
                      >
                        <Box
                          noValidate
                          autoComplete="off"
                        >
                          <TextField
                            label=""
                            defaultValue=""
                            onChange={handleInputChange}
                            type="file"
                            name="image"
                          />
                        </Box>
                      </div>
                    </div>
                    <br />
                    <Divider sx={{ my: 0.5 }} />
                    <div className="row">
                      <label style={{ marginTop: "8px" }}>
                        <b>SET PRICE DETAILS</b>{" "}
                      </label>{" "}
                    </div>

                    {/* Quantity Price moved below Variety Group selection for better UX */}

                    {/* === Enable Weight Pricing Checkbox === */}
                    <div className="row">
                      <div
                        className="col"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          type="checkbox"
                          checked={priceType === "weight"}
                          onChange={() =>
                            setPriceType((prev) =>
                              prev === "weight" ? "quantity" : "weight"
                            )
                          }
                          style={{
                            height: "25px",
                            width: "25px",
                            marginRight: "10px",
                            cursor: "pointer",
                            accentColor: "rgb(54, 34, 204)",
                          }}
                        />
                        Weight ?
                      </div>
                    </div>

                    {/* === Weight Price Section (Shown only if checkbox is checked) === */}
                    {priceType === "weight" && (
                      <div className="row">
                        <div className="col">
                          <FormControl sx={{ m: 1, minWidth: 120 }}>
                            <InputLabel>Weight Unit</InputLabel>
                            <Select
                              value={weightUnit}
                              onChange={(e) => setWeightUnit(e.target.value)}
                              label="Weight Unit"
                            >
                              <MenuItem value="kg">KG</MenuItem>
                              <MenuItem value="liter">Liter</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                        <div className="col">
                          <TextField
                            fullWidth
                            label={`Price (per ${weightUnit})`}
                            onChange={(e) => setWeightPrice(e.target.value)}
                            type="number"
                            name="weight_price"
                            value={weightPrice}
                          />
                        </div>
                      </div>
                    )}

                    {/* === Additional Controls === */}
                    <div className="row">
                      <div
                        className="col"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          onChange={() => setEditablePrice(!isPriceEditable)}
                          type="checkbox"
                          name="isPriceEditable"
                          style={{
                            height: "25px",
                            width: "25px",
                            marginLeft: "5px",
                            cursor: "pointer",
                            accentColor: "rgb(54, 34, 204)",
                          }}
                          checked={isPriceEditable}
                        />
                        <label style={{ marginLeft: "10px", marginTop: "3px" }}>
                          Editable Price?
                        </label>
                      </div>

                      <div className="col" style={{ display: "flex" }}>
                        <input
                          onChange={handleChangeVariety}
                          type="checkbox"
                          name="variety"
                          style={{
                            height: "25px",
                            width: "25px",
                            marginLeft: "5px",
                            cursor: "pointer",
                            accentColor: "rgb(54, 34, 204)",
                          }}
                          checked={variety}
                        />
                        <label
                          style={{ marginLeft: "10px", marginTop: "3px" }}
                          htmlFor=""
                        >
                          Has Varieties ?
                        </label>
                      </div>

                      <div
                        style={{
                          display: variety ? "block" : "none",
                        }}
                        className="col"
                      >
                        <FormControl sx={{ m: 1, minWidth: 150 }}>
                          <InputLabel id="variety-group-label" htmlFor="">
                            Variety Group
                          </InputLabel>
                          <Select
                            labelId="variety-group-label"
                            id="variety-group-select"
                            value={select}
                            onChange={handleSelectChange}
                            label="Variety Group"
                          >
                            {option.map((opt) => (
                              <MenuItem key={opt.id} value={opt.id}>{opt.name}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>

                    {/* Variety Price Inputs (Restored/Improved flow) */}
                    {variety && select && (
                      <div className="row" style={{ marginTop: "10px" }}>
                        <div id="itemPrice" style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                          {(optMap || []).flat().map((item, index) => (
                            <div className="col" key={index} style={{ marginBottom: "10px" }}>
                              <TextField
                                size="small"
                                label={`${item} - Quantity Price`}
                                variant="outlined"
                                value={pricevalues[item] || ""}
                                onChange={(e) =>
                                  SetPriceValues((prev) => ({
                                    ...prev,
                                    [item]: e.target.value,
                                  }))
                                }
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    <div className="row" style={{ marginTop: variety ? '10px' : '0' }}>
                      {!variety && (
                        <div className="col">
                          <TextField
                            size="small"
                            label="Item Price"
                            onChange={(e) => setPrice(e.target.value)}
                            type="number"
                            name="price"
                            value={price}
                          />
                        </div>
                      )}
                      <div className="col">
                        <TextField

                          label="Online Price Increase"
                          onChange={(e) => setOnlineIncreaseBy(e.target.value)}
                          type="number"
                          size="small"
                          name="onlineIncreaseBy"
                          value={onlineIncreaseBy}
                        />
                      </div>
                      {variety && <div className="col"></div>}
                    </div>
                    <Divider sx={{ my: 0.5 }} />
                    <div className="row">
                      <label style={{ marginTop: "8px" }}>
                        <b>SET CONTAINER PRICE</b>{" "}
                      </label>{" "}
                    </div>

                    <div className="row">
                      <div className="col" style={{ display: "flex" }}>
                        <input
                          type="checkbox"
                          name="isContainer"
                          style={{
                            height: "25px",
                            width: "25px",
                            marginLeft: "5px",
                            cursor: "pointer",
                            accentColor: "rgb(54, 34, 204)",
                          }}
                          checked={isContainer}
                          onChange={(e) => {
                            setIsContainer(e.target.checked);
                            if (!e.target.checked) setContainerPrice(0); // Optional: reset price
                          }}
                        />

                        <label
                          style={{ marginLeft: "10px", marginTop: "3px" }}
                          htmlFor=""
                        >
                          Is Container ?
                        </label>
                      </div>
                    </div>

                    {isContainer && (
                      <div className="row">
                        <div
                          style={{
                            display: variety ? "block" : "none",
                          }}
                        >
                          <div id="containerPrices">
                            {optMap.flat().map((item, index) => (
                              <div className="col" key={index}>
                                <TextField
                                  size="small"
                                  label={`${item} - Container Price`}
                                  variant="outlined"
                                  value={containerPriceValues[item] || ""}
                                  style={{ marginRight: "10px" }}
                                  onChange={(e) =>
                                    setTextValue(
                                      e.target.value,
                                      item,
                                      "container"
                                    )
                                  }
                                />
                              </div>
                            ))}
                          </div>
                        </div>

                        <div
                          className="col"
                          style={{ display: variety ? "none" : "block" }}
                        >
                          <TextField
                            fullWidth
                            label="Container Price"
                            onChange={handleContainerPriceChange}
                            type="number"
                            name="containerPrice"
                            value={containerPrice}
                          />
                        </div>
                      </div>
                    )}

                    <Divider sx={{ my: 0.5 }} />
                    <div className="row">
                      <label style={{ marginTop: "8px" }}>
                        <b>ADDITIONAL DETAILS</b>{" "}
                      </label>{" "}
                    </div>
                    <div className="row">
                      <div className="col" style={{ marginTop: "8px" }}>
                        <TextField

                          label="Calorie"
                          defaultValue=""
                          onChange={handleCalorieChange}
                          type="number"
                          name="calorie"
                          value={calorie}
                        />
                      </div>

                      <div className="col">
                        <FormControl sx={{ m: 1, minWidth: 150 }}>
                          <InputLabel id="demo-simple-select-helper-label">
                            In Stock
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            value={inStock}
                            label="In Stock"
                            onChange={handleInStockChange}
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            <MenuItem value={true} selected={proStack}>
                              Yes
                            </MenuItem>
                            <MenuItem value={false} selected={!proStack}>
                              No
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col">
                        <FormControl sx={{ m: 1, minWidth: 150 }}>
                          <InputLabel id="demo-simple-select-helper-label">
                            Food Type
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            label="Food Type"
                            value={categoryType || "Non-Veg"}
                            onChange={handleCategoryType}
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            <MenuItem value="Veg">Veg</MenuItem>
                            <MenuItem value="Non-Veg">Non-Veg</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>

                    <div className="row">


                      <div className="col">
                        <ul id="tags">
                          {cooktags && cooktags.length ? (
                            cooktags.length &&
                            cooktags.map((cooktags, index) => (
                              <li key={index} className="tag">
                                <span className="tag-title">{cooktags}</span>
                                <span
                                  className="btn"
                                  onClick={() => removeTags(index)}
                                >
                                  x
                                </span>
                              </li>
                            ))
                          ) : (
                            <span className="tag-title"></span>
                          )}{" "}
                        </ul>
                        <TextField

                          label="Cooking Instruction"
                          defaultValue=""
                          onKeyUp={(event) =>
                            event.key === "Enter" ? addTags(event) : null
                          }
                          placeholder="Press Enter to Add new"
                          type="text"
                        />

                      </div>

                      <div className="col">
                        <FormControl sx={{ m: 1, minWidth: 150 }}>
                          <InputLabel id="kitchen-select-label">
                            Assign Kitchen
                          </InputLabel>
                          <Select
                            labelId="kitchen-select-label"
                            id="kitchen-select"
                            value={selectedKitchen}
                            label="Assign Kitchen"
                            onChange={handleKitchenChange}
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            {kitchenList.map((kitchen) => (
                              <MenuItem key={kitchen.id} value={kitchen.id}>
                                {kitchen.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>

                    <Divider sx={{ my: 0.5 }} />
                    <div className="row">
                      <div className="col" style={{ display: showAddon ? "block" : "none" }}>
                        <label
                          style={{ marginTop: "10px", marginLeft: "10px" }}
                          htmlFor=""
                        >
                          Add-on Categories
                        </label>
                        <div className="tags-input " style={{ display: "block" }}>
                          <div id="addons">
                            {addOn.map((tag, index) => {

                              let addName = categories.filter(
                                (li) => li.id === tag
                              );
                              addName = addName.length ? addName[0].name : "";
                              return (
                                <span key={index} className="tag">
                                  <span className="tag-title">{addName}</span>
                                  <span
                                    className="rmv-btn"
                                    onClick={() => removeAddons(index)}
                                  >
                                    x
                                  </span>
                                </span>
                              );
                            })}
                          </div>

                          <select
                            className="select_input"
                            style={{ marginTop: "10px" }}
                            onChange={handleAddOns}
                          >
                            <option>Select</option>
                            {categories
                              .filter((cat) => cat.isAddOn)
                              .map((li) => (
                                <option value={li.id}>{li.name}</option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="col"></div>
                      {false && <div className="col">
                        <Box
                          noValidate
                          autoComplete="off"
                        >
                          <ul id="tagss">
                            {tags && tags.length ? (
                              tags.length &&
                              tags.split(',').map((tag, index) => (
                                <li key={index} className="tag">
                                  <span className="tag-title">{tag}</span>
                                  <span
                                    className="btn"
                                    onClick={() => removeTags(index)}
                                  >
                                    x
                                  </span>
                                </li>
                              ))
                            ) : (
                              <span className="tag-title"></span>
                            )}{" "}
                          </ul>
                          <TextField
                            label="Tags"
                            defaultValue=""
                            onChange={handleTagsChange}
                            //className="input_cls"
                            type="text"
                            name="tags"
                            placeholder="Comma separated"
                            value={tags}
                          />
                        </Box>
                      </div>}
                    </div>


                    <div className="row">
                      <label style={{ marginLeft: "8px" }} >
                        <b>SKU, ESL & Other Data</b>
                      </label>
                    </div>
                    <div className="row">
                      <div className="col" style={{ marginLeft: "20px" }}>
                        <TextField
                          fullWidth
                          type="number"
                          label="Base Price"
                          defaultValue=""
                          onChange={handleBasePriceChange}
                          name="BasePrice"
                          value={basePrice}
                        />
                      </div>
                      <div className="col" style={{ marginLeft: "20px" }}>
                        <TextField
                          fullWidth
                          type="number"
                          label="Tax"
                          defaultValue=""
                          onChange={handleTaxChange}
                          name="tax"
                          value={tax}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col" style={{ marginLeft: "20px" }}>
                        <TextField
                          fullWidth
                          label="SKU ID"
                          defaultValue=""
                          onChange={handleSkuChange}
                          name="sku_id"
                          value={SKU_id}
                        />
                      </div>
                      <div className="col" style={{ display: "flex" }}>
                        <input
                          type="checkbox"
                          name="hasESL?"
                          style={{
                            height: "25px",
                            width: "25px",
                            marginLeft: "5px",
                            cursor: "pointer",
                            accentColor: "rgb(54, 34, 204)",
                          }}
                          checked={hasESL}
                          onChange={(e) => {
                            setHasESL(e.target.checked);
                            if (!e.target.checked) setHasESL(0); // Optional: reset price
                          }}
                        />

                        <label
                          style={{ marginLeft: "10px", marginTop: "3px" }}
                          htmlFor=""
                        >
                          Has Electronic Shelf Label (ESL) ?
                        </label>
                      </div>
                    </div>
                    {
                      hasESL && <div className="row">
                        <div className="col" style={{ display: "flex" }}>
                          <div>
                            <TextField
                              fullWidth
                              label="ESL Label code"
                              defaultValue=""
                              onChange={handleESLCodeChange}
                              name="eslCode"
                              value={eslCode}
                            />
                          </div>


                        </div>
                      </div>
                    }

                    <Divider sx={{ my: 2 }} />
                    <div className="row">
                      <label style={{ marginLeft: "8px" }}><b>Product Gallery Images (Max 5)</b></label>
                    </div>
                    <div className="row" style={{ marginTop: "10px", paddingLeft: "10px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
                      {itemImgCollection.map((img, idx) => (
                        <div key={idx} style={{ position: "relative", width: "80px", height: "80px", border: "1px solid #ccc", borderRadius: "5px", overflow: "hidden" }}>
                          <img src={img} style={{ width: "100%", height: "100%", objectFit: "cover" }} alt={`Gallery ${idx}`} />
                          <div
                            style={{ position: "absolute", top: 0, right: 0, background: "rgba(255,0,0,0.7)", color: "#fff", cursor: "pointer", width: "20px", height: "20px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", zIndex: 2 }}
                            onClick={() => {
                              const newColl = [...itemImgCollection];
                              newColl.splice(idx, 1);
                              setItemImgCollection(newColl);
                            }}
                          >x</div>
                        </div>
                      ))}
                      {itemImgCollection.length < 5 && (
                        <div
                          style={{ width: "80px", height: "80px", border: "1px dashed #ccc", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", backgroundColor: "#f9f9f9" }}
                          onClick={() => setShowGalleryCollection(true)}
                        >
                          <AddIcon />
                        </div>
                      )}
                    </div>

                  </form>
                </>
              ) : (
                ""
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              color="error"
              style={{ margin: "10px" }}
              className="close-btn"
              onClick={handleClose}
            >
              Close
            </Button>
            <Button
              className="save-btn btnDialog-Fill"
              variant="contained"
              color="success"
              style={{ margin: "10px" }}
              disabled={!foodName || isUploading}
              onClick={handleSubmit}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        {openDeleteDialog === true ? (
          <DeleteDiaologue
            open={openDeleteDialog}
            onClose={handleDeleteClose}
            onConfirm={handleConfirmDelete}
            itemName={deleteItemName}
          />
        ) : (
          <div />
        )}

        <Dialog
          onClose={() => setShowGallery(false)}
          open={showGallery}
          fullWidth={true}
          style={{ width: "600px", margin: "auto" }}
        >

          <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <Gallery
              onSelectImage={handleSelectedImage}
              foodName={foodName}
            />
          </div>

          <div
            className="footer"
            style={{
              flex: "0 0 auto",
              padding: "8px",
              borderTop: "1px solid #ccc",
              position: "sticky",
              bottom: "0",
              backgroundColor: "#fff",
              zIndex: "1",
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              variant="outlined"
              color="warning"
              onClick={() => setShowGallery(false)}
            >
              Cancel
            </Button>
            <Button
              style={{ background: "#f7c919" }}
              variant="contained"
              onClick={handleSubmitImage}
            >
              SELECT
            </Button>
          </div>

        </Dialog>

        <Dialog
          onClose={() => setShowGalleryCollection(false)}
          open={showGalleryCollection}
          fullWidth={true}
          style={{ width: "600px", margin: "auto" }}
        >
          <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <Gallery
              onSelectImage={(img) => {
                if (itemImgCollection.length < 5 && img && img.image) {
                  setItemImgCollection([...itemImgCollection, img.image]);
                  setShowGalleryCollection(false);
                }
              }}
              foodName={foodName}
            />
          </div>
          <div
            className="footer"
            style={{
              flex: "0 0 auto", padding: "8px", borderTop: "1px solid #ccc",
              position: "sticky", bottom: "0", backgroundColor: "#fff",
              zIndex: "1", display: "flex", justifyContent: "space-between", width: "100%"
            }}
          >
            <Button variant="outlined" color="warning" onClick={() => setShowGalleryCollection(false)}>
              Cancel
            </Button>
          </div>
        </Dialog>

        <div className="product-list">
          <Table width="100%" cellPadding="4px">
            <Thead>
              <Tr>
                {[
                  <Th key="checkbox">
                    <input
                      type="checkbox"
                      checked={
                        prod.length > 0 &&
                        prod
                          .filter((p) => {
                            if (!selectedCategory) return true;
                            const categoryMatch = catAddon.find(
                              (cat) =>
                                (p.category.id || p.category) ===
                                (cat._id || cat.id)
                            );
                            return (
                              categoryMatch &&
                              categoryMatch.name === selectedCategory
                            );
                          })
                          .every((p) => selectedProducts.includes(p.id))
                      }
                      onChange={() =>
                        handleSelectAll(
                          prod.filter((p) => {
                            if (!selectedCategory) return true;
                            const categoryMatch = catAddon.find(
                              (cat) =>
                                (p.category.id || p.category) ===
                                (cat._id || cat.id)
                            );
                            return (
                              categoryMatch &&
                              categoryMatch.name === selectedCategory
                            );
                          })
                        )
                      }
                      style={{
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                        accentColor: "rgb(54, 34, 204)",
                      }}
                    />
                  </Th>,
                  <Th key="name">Name</Th>,
                  <Th key="images">Images</Th>,
                  <Th key="price">Price(Q/W)</Th>,
                  <Th key="category">Category</Th>,
                  <Th key="instock">Instock</Th>,
                  userData?.role === 'Admin' && <Th key="action">Action</Th>
                ].filter(Boolean)}
              </Tr>
            </Thead>

            <Tbody>
              {prod.length
                ? prod
                  .filter((p) => {
                    if (!selectedCategory) return true; // Show all products if no category is selected
                    const categoryMatch = catAddon.find(
                      (cat) =>
                        (p.category.id || p.category) === (cat._id || cat.id)
                    );
                    return (
                      categoryMatch && categoryMatch.name === selectedCategory
                    );
                  })
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((p) => {
                    let cat_name =
                      catAddon && catAddon.length
                        ? catAddon.filter(
                          (cat) =>
                            (p.category.id ? p.category.id : p.category) ===
                            (cat._id ? cat._id : cat.id)
                        )
                        : [];
                    cat_name = cat_name.length ? cat_name[0].name : "";

                    return (
                      <Tr
                        key={p.id}
                        style={{
                          borderBottom: "1px solid #f0eeee",
                          margin: "5px",
                        }}
                      >
                        {[
                          <Td key="checkbox">
                            <input
                              type="checkbox"
                              checked={selectedProducts.includes(p.id)}
                              onChange={() => handleSelectItem(p.id)}
                              style={{
                                cursor: "pointer",
                                width: "20px",
                                height: "20px",
                                accentColor: "rgb(54, 34, 204)",
                              }}
                            />
                          </Td>,
                          <Td
                            key="name"
                            style={{
                              overflow: "hidden",
                              whiteSpace: "wrap",
                              fontWeight: "bold",
                            }}
                          >
                            {p.name}
                          </Td>,
                          <Td key="images" style={{ padding: "10px 0px" }}>
                            <img
                              src={
                                p.image === "" ? "/images/blank.jpg" : p.image
                              }
                              alt={p.name}
                              onError={imageOnErrorHandler}
                              style={{
                                width: "80px",
                                height: "40px",
                                borderRadius: "5px",
                              }}
                            />
                          </Td>,
                          <Td key="price">
                            {p.isPriceVariety && p.varietyPrices && selectedCurrency}
                            {p.isPriceVariety && p.varietyPrices
                              ? Object.values(JSON.parse(p.varietyPrices)).join(
                                '/'
                              )
                              : formatter.format(p.price || p.weight_price).replace('JMD', 'J$').replace(/\s+/, "")}
                            {p.weight_price ? " /W" : " /Q"}
                          </Td>,
                          <Td key="category">{cat_name}</Td>,
                          <Td key="instock">
                            <input
                              type="checkbox"
                              checked={p.inStock}
                              onChange={() => handleStocks(p)}
                              style={{
                                width: "40px",
                                height: "20px",
                                accentColor: "#31e631",
                                cursor: "pointer",
                              }}
                            />
                          </Td>,
                          userData?.role.toLowerCase() !== 'member' && (
                            <Td key="action">
                              {!merchCode.activeProviderId && (
                                <div style={{ position: 'relative' }}>
                                  <Button
                                    aria-controls={openActions ? 'demo-customized-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={openActions ? 'true' : undefined}
                                    variant="outlined"
                                    disableElevation
                                    onClick={() => handleActionsClick(p.id)}
                                    endIcon={<KeyboardArrowDownIcon />}
                                  >
                                    Actions
                                  </Button>
                                  {openActions && p.id === selectProductId && (
                                    <Paper style={{ position: 'absolute', zIndex: "99", right: 0, top: '100%' }}>
                                      <MenuList open={false} onClose={handleActionsClose}>
                                        <MenuItem onClick={() => (handleActionsClose(),
                                          handleEdit(
                                            p.id,
                                            p.image,
                                            p.category,
                                            p.cat_type,
                                            p.inStock,
                                            p
                                          ))
                                        } >
                                          <EditIcon />
                                          Edit
                                        </MenuItem>
                                        <MenuItem onClick={() => (showInventoryDialog(p), handleActionsClose())} >
                                          <AddLinkIcon />
                                          Link Inventory
                                        </MenuItem>
                                        <MenuItem onClick={() => (showOffersDialog(p), handleActionsClose())} >
                                          <LocalOfferIcon />
                                          Manage Offer
                                        </MenuItem>
                                        <MenuItem onClick={() => handleActionsClose()} >
                                          <FileCopyIcon />
                                          Duplicate
                                        </MenuItem>
                                        {p.hasESL && <MenuItem onClick={() => (toast.success("ESL Update Published"), handleActionsClose())} >
                                          <FileCopyIcon />
                                          Publish To ESL
                                        </MenuItem>}
                                        <Divider sx={{ my: 0.5 }} />
                                        <MenuItem onClick={() => (setDeleteItemId(p.id), setDeleteItemName(p.name), handleActionsClose(), setOpenDeleteDialog(true))} >
                                          <DeleteIcon />
                                          Delete
                                        </MenuItem>
                                      </MenuList>
                                    </Paper>
                                  )}
                                </div>
                              )}
                            </Td>
                          )
                        ].filter(Boolean)}
                      </Tr>
                    );
                  })
                : null}
            </Tbody>
          </Table>
          {prod && prod.length > 0 && (
            <TablePagination
              rowsPerPageOptions={[7, 10, 25]}
              component="div"
              count={prod.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </div>

        {showInventory && <InventoryProLink product={showInventory}
          variety={option}
          getVarietyOptions={getVarietyOptions}
          setShowInventory={setShowInventory}
          showSucMessg={() => toast.success("Saved successfully!")}
          showErrMessg={() => toast.error("Save failed!")}
        />}
        {showOffers && <ProductOffers product={showOffers}
          setShowOffers={setShowOffers}
        />}
      </div>
      <ToastContainer />
    </>
  );
}

export default FoodDescription;
